// extracted by mini-css-extract-plugin
export default {"content":"Attachments_content__N4sLl","contentPdf":"Attachments_contentPdf__uDYpS","contentError":"Attachments_contentError__5Hhkf","toggleButton":"Attachments_toggleButton__Pv0eK"};